import { defineMessages } from 'react-intl';

export const computerUseMessages = defineMessages({
  stop: {
    defaultMessage: 'Stop',
    id: 'q/uwLTb3Zf',
  },
  stopLabel: {
    defaultMessage: 'Stop desktop task',
    id: 'uCtgWpGfYY',
  },
  stopping: {
    defaultMessage: 'Stopping…',
    id: 'NACfNicI6z',
  },
  stoppingLabel: {
    defaultMessage: 'Stopping desktop task',
    id: 'YBRSsCDXAh',
  },
  notStartedReason: {
    defaultMessage: 'Didn’t start working the screen.',
    id: 'Eddxa8RA1i',
    description: 'Computer-use task status shown when the user denies start approval',
  },
  stoppedReason: {
    defaultMessage: 'Stopped working the screen.',
    id: 'r8SUgWiWwF',
    description: 'Computer-use task status shown after the task is cancelled',
  },
  familyLabel: {
    defaultMessage: 'Working the screen',
    id: '9j4lEpJQ25',
    description:
      'Family label under the goal on a computer-use card: Heidi is driving the screen itself',
  },
  planRunning: {
    defaultMessage: 'Using your computer',
    id: 'kOSE82Wt8d',
    description: 'Trailing status on a running computer-use plan card header',
  },
  planApprovalNote: {
    defaultMessage:
      'Heidi will see your screen and click or type to carry out this plan.',
    id: 'uD6XlX3ZZo',
    description: 'Note beside the actions on a computer-use plan awaiting approval',
  },
  workingFor: {
    defaultMessage: 'Working for {elapsed}',
    id: 'vlgkhaBKoH',
    description:
      'Header above the live activity list while a computer-use task runs; {elapsed} is a duration like "3m 27s"',
  },
  workedFor: {
    defaultMessage: 'Worked for {elapsed}',
    id: 'BtVQ87+s5J',
    description:
      'Header above the activity list once a computer-use task has finished; {elapsed} is a duration like "3m 27s"',
  },
  running: {
    defaultMessage: 'Running',
    id: 'CxbeS4v0ND',
    description: 'Computer-use task status badge while executing',
  },
  runningWithStep: {
    defaultMessage: 'Running · step {count}',
    id: '3nGKZC5R1o',
    description: 'Running computer-use task status with its current step count',
  },
  done: {
    defaultMessage: 'Done',
    id: 'mv6OUSbyFA',
    description: 'Computer-use task status badge on success',
  },
  cancelled: {
    defaultMessage: 'Canceled',
    id: 'XtcQmry/xZ',
    description: 'Computer-use task status badge when canceled',
  },
  stopped: {
    defaultMessage: 'Stopped',
    id: 'nU6tHrd1TF',
    description: 'Computer-use task status badge when stopped with error',
  },
  errorFallbackReason: {
    defaultMessage: "Couldn't finish this step.",
    id: 'F9R8u5FTEu',
    description:
      'Computer-use error when the upstream reason is blank, too long, or narrates other windows',
  },
});
